import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

	constructor() { }

	ngOnInit() { }

	public getCurrentYear(): number {
		return new Date().getFullYear();
	}

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts